import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';

import CustomDropdownWithButtonAndPrompt from 'components/base/CustomDropdownWithButtonAndPrompt';
import { PermissionCodes } from 'config/PermissionCodes';
import './BrandSelectDropdown.scss';
import { createAction } from 'utils';

function StoreDropdownWithButtonAndPrompt({
  title,
  valueFieldName,
  customOnChange = () => { },
  onFocus = () => { },
  description,
  hasAddButton = false,
  addButtonInfo,
  promptConfig,
  isPrompt = false,
  formErrorId = valueFieldName,
  defaultFilter = {},
  labelContainPk = true,
}) {
  const dispatch = useDispatch();
  const { watch, formState: { errors }, setValue } = useFormContext();
  const watchStore = watch(valueFieldName)
  const defaultValue = {
    value: watchStore,
    label: labelContainPk 
      ? watchStore?.pk ? `[ID: ${watchStore?.pk}] ${watchStore?.name}` : watchStore?.name
      : watchStore?.name,
  }
  const { storeList } = useSelector((state) => ({
    storeList: state.storeModel.storeList || [], 
  }));

  const defaultAddButtonInfo = {
    title: 'Create Now',
    requires: PermissionCodes.addStore,
    customClass:
      'general-section-add-new-brand btn-add-button-common',
  }
  const onSelectChange = (value) => {
    if (valueFieldName) {
      setValue(valueFieldName, value?.value || {}, { shouldDirty: true })
    }
    customOnChange(value?.value);
  };

  const jsonTypeDefaultFilter = JSON.stringify(defaultFilter)

  useEffect(() => {
    dispatch(
      createAction('storeModel/getPagedStoreList')(defaultFilter),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonTypeDefaultFilter]);

  return (
    <CustomDropdownWithButtonAndPrompt
      title={title}
      description={description}
      titleStyle={isPrompt ? '' : 'create-section-label-no-top-space'}
      defaultValue={defaultValue}
      setValue={onSelectChange}
      source={storeList}
      hasAddButton={hasAddButton}
      addButtonInfo={hasAddButton ? { ...defaultAddButtonInfo, ...addButtonInfo } : {}}
      onFocus={onFocus}
      labelContainPk={labelContainPk}
      errors={errors}
      formErrorId={formErrorId}
      promptConfig={promptConfig}
      loadMoreAction={'storeModel/getPagedStoreList'}
      filterAction={'storeModel/getPagedStoreList'}
      defaultFilter={defaultFilter}
    />
  )
}

export default StoreDropdownWithButtonAndPrompt;
